import React from 'react';
import usePicTime from './hooks/usePicTime';
import { Button } from '@/src/shadComponents/ui/button';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/src/shadComponents/ui/card';
import { Badge } from '@/src/shadComponents/ui/badge';

export default function PicTime() {
    const { isLinked, unlinkAccount, accountName } = usePicTime();
    return (
        <Card className="mx-8">
            <CardHeader>
                <CardTitle>Pic-Time</CardTitle>
                <CardDescription>
                    Pic-Time is a professional photo gallery platform that
                    allows you to create and share your photo galleries with
                    clients. Enabling this integration will allow you to link
                    your Pic-Time account to your Photo Engineers account
                    allowing for automatic gallery synchronization.
                </CardDescription>
            </CardHeader>
            <CardContent>
                <div className="flex items-center justify-end gap-3">
                    <span className="flex-1"></span>
                    {isLinked ? (
                        <>
                            <Badge variant="secondary">
                                Linked to: {accountName}
                            </Badge>
                            <Button
                                variant="outline"
                                onClick={unlinkAccount}
                            >
                                Unlink Account
                            </Button>
                        </>
                    ) : (
                        <Button asChild>
                            <a
                                href={`https://smileboothtest.pic-time.com/oauth?responseType=accessToken&appId=AAAAAI8AAAC5kp6fo0ayQ4MaDSqN_Rt1dHgq&redirectUrl=${encodeURIComponent(
                                    'https://photostat.smilebooth.com/integrations/pic-time/redirect',
                                )}`}
                            >
                                Link your Pic-Time account
                            </a>
                        </Button>
                    )}
                </div>
            </CardContent>
        </Card>
    );
}
